(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderTemplate',
	};

	var $modal               = $('.modal');
	var $form_name           = 'form_component_data[FitBuilderTemplate]';
	var $label_name          = 'fitbuildertemplate';
	var $id_field_pieces     = [];
	var $id_field_piece_name = '';
	var $id_field            = '';
	var $name_field          = '';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// template instructions
		$('.toggle-form-control').on('click', function onMinusClick(e)
		{
			var $self = $(this);
			$self.toggleClass('plus');
			$self.toggleClass('minus');

			$('.template-desc').collapse('toggle');
		});

		// toggle global/custom banner fields
		$('.image-type > .btn-radio').click(function _imageTypeClicked() {
			var data_type = $(this).data('type');

			if (data_type === 'global') {
				// global banner
				$('.global-banner').removeClass('hidden');
				$('.custom-banner').addClass('hidden');
			} else {
				// custom banner
				$('.global-banner').addClass('hidden');
				$('.custom-banner').removeClass('hidden');
			}
		});

		// custom banner
		$('.remove-banner').click(function _removeCustomBanner(e) {
			e.preventDefault();

			$('#fitbuildertemplate-image_name').val('');
			$('#fitbuildertemplate-remove_banner').val('1');
			$('.selected-banner').attr('src', '');

			$('.selected-banner-remove').addClass('hidden');
		});

		// main picture
		$('.fit-builder-template-library-select').click(function _showImagePicker(e) {
			e.preventDefault();

			showImagePicker();
		});

		$('.remove-image').click(function _removeLibraryImage(e) {
			e.preventDefault();

			$('#fitbuildertemplate-picture').val('');
			$('#fitbuildertemplate-library_image').val('');
			$('#fitbuildertemplate-remove_picture').val('1');
			$('.selected-image').attr('src', '');

			$('.selected-image-remove').addClass('hidden');
		});

		// enable add day and add travel component links
		addDayEvent();
		addComponentEvent();

		// init the day listeners
		$('.day-container').each(function onEachDayElement(i, elem) {
			var day = $(elem).data('day');

			initDayListeners(day);
		});

		// init the component field listeners
		$('.component-container').each(function onEachComponentElement(i, elem) {
			var day       = $(elem).data('day'),
				component = $(elem).data('component');

			// attach events
			initComponentFieldListeners(day, component);
		});
	};

	/**
	 * When clicking the "Add Travel Component" link
	 *
	 * @return {void}
	 */
	function addComponentEvent()
	{
		$('.add-component').off().click(function onComponentClick(event)
		{
			var day_number            = $(this).data('day');
			var day_index             = day_number - 1;
			var day_container         = $('.day-container[data-day="' + day_number + '"]');
			var next_component_index  = null;
			var next_component_number = null;
			var component_markup      = $('.component-container').last().clone();
			var component_day         = null;
			var component_parent      = day_container.find('.box-content');

			event.preventDefault();

			day_container.find('.day-info-text').addClass('hidden');
			day_container.find('.day-required-text').removeClass('hidden');

			// figure out the component index/next number
			next_component_index  = $('.day-container[data-day="' + day_number + '"] .component-container').length;
			next_component_number = (next_component_index + 1);

			// get the component markup day
			component_day = component_markup.data('day');

			if (component_day !== day_number) {
				// we have a component from a different day
				// update the component container day
				component_markup.attr('data-day', day_number);

				// update the day number on all of the elements
				component_markup.find('[data-day="' + component_day + '"]').each(function onEachElement(i, elem) {
					// change data attributes on the markup elements
					$(elem).attr('data-day', String(day_number));
				});
			}

			// set the container component number
			component_markup.attr('data-component', next_component_number);

			// update the travel component header number
			component_markup.find('.component-title').html(next_component_number);

			// set data attributes for the created component
			// update the number on all of the component elements
			component_markup.find('[data-day="' + day_number + '"]').each(function onEachComponentElement(i, elem) {
				// change data attributes on the markup elements
				$(elem).attr('data-component', String(next_component_number));
			});

			component_markup.find('.has-error').each(function onEachErrorElement(i, elem) {
				// remove has-error class
				$(elem).removeClass('has-error');
			});

			// update the remove button component number
			component_markup.find('.remove-component').attr('data-component', next_component_number);

			// update index for the id and name on the form fields
			component_markup.find('.component-field').each(function onEachComponentElement(i, elem) {
				var numeric_key = '';

				// change the field id
				if ($(elem).attr('id')) {
					$id_field_pieces     = $(elem).attr('id').split('-');
					$id_field_piece_name = $id_field_pieces.pop();

					// need to avoid numeric keys if the field name is based on radio buttons
					if (isNaN(parseInt($id_field_piece_name)) === false) {
						numeric_key          = '-' + $id_field_piece_name;
						$id_field_piece_name = $id_field_pieces.pop();
					}

					$id_field = $label_name + '-days-' + day_index + '-components-' + next_component_index + '-' + $id_field_piece_name + numeric_key;

					$(elem).attr('id', $id_field);
				}

				// change the field name
				$name_field = $form_name + '[days][' + day_index + '][components][' + next_component_index + '][' + $id_field_piece_name + ']';

				$(elem).attr('name', $name_field);
			});

			// reset text editor fields so they can be re-initialized
			component_markup.find('.vendor-notes[data-day="' + day_number + '"][data-component="' + next_component_number + '"]').html(
				'<textarea type="textarea" class="form-control component-field" data-day="' + day_number + '" data-component="' + next_component_number + '" name="form_component_data[FitBuilderTemplate][days][' + day_index + '][components][' + next_component_index + '][vendor_notes]" id="' + $label_name + '-days-' + day_index + '-components-' + next_component_index + '-vendor_notes"></textarea>'
			);

			component_markup.find('.description[data-day="' + day_number + '"][data-component="' + next_component_number + '"]').html(
				'<textarea type="textarea" class="form-control component-field" data-day="' + day_number + '" data-component="' + next_component_number + '" name="form_component_data[FitBuilderTemplate][days][' + day_index + '][components][' + next_component_index + '][description]" id="' + $label_name + '-days-' + day_index + '-components-' + next_component_index + '-description"></textarea>'
			);

			// add the new component to the dom
			component_parent.append(component_markup);

			// attach events
			initComponentFieldListeners(day_number, next_component_number);

			// reset component fields
			resetComponentFields(day_number, next_component_number);

			// remove hidden class if there is more than 1 component in the day
			day_container.find('.remove-component-container').each(function onEachRemoveComponentElement(i, elem) {
				if (day_number > 1 || next_component_number > 1) {
					$(elem).removeClass('hidden');
				} else {
					$(elem).addClass('hidden');
				}
			});
		});
	}

	/**
	 * When clicking the "Add Day" button
	 *
	 * @return {void}
	 */
	function addDayEvent()
	{
		$('.add-day').off().click(function onDayClick(event)
		{
			var current_day_count = $('.day-container').length;
			var day_number        = current_day_count + 1;
			var day_index         = current_day_count;
			var day_markup        = $('.day-container').last().clone();
			var day_parent        = $('.days-container');

			event.preventDefault();

			// clear out the components
			day_markup.find('.box-content').html('');

			// update the hidden day number field
			$id_field   = $label_name + '-days-' + day_index + '-day_number';
			$name_field = $form_name + '[days][' + day_index + '][day_number]';

			day_markup.find('.day-number')
					  .val(day_number)
					  .attr({
						id  : $id_field,
						name: $name_field
					});

			// update the day number on all of the elements
			day_markup.find('[data-day="' + day_index + '"]').each(function onEachElement(i, elem) {
				// change data attributes on the markup elements
				$(elem).attr('data-day', String(day_number));
			});

			// set the container day number
			day_markup.attr('data-day', day_number);

			// update the day header number
			day_markup.find('.day-title').html(day_number);

			// display remove day button
			day_markup.find('.remove-day-container').removeClass('hidden');

			// show the info text / hide the required text
			day_markup.find('.day-info-text[data-day="' + day_number + '"]').removeClass('hidden');
			day_markup.find('.day-required-text[data-day="' + day_number + '"]').addClass('hidden');

			// add the new day to the dom
			day_parent.append(day_markup);

			// re-attach events
			initDayListeners(day_number);

			// enable add component link
			addComponentEvent();

			// day being add, so remove hidden classes
			$('.days-container').find('.remove-day-container').each(function onEachRemoveDayElement(i, elem) {
				$(elem).removeClass('hidden');
			});
		});
	}

	function getAllInclusiveProperties(day, component, vendor_id)
	{
		var $properties_select = $('.ai-property-select[data-day="' + day + '"][data-component="' + component + '"]'),
		    property_id;

		// reset stuff
		$properties_select.empty();
		$properties_select.append($('<option>').text('').attr('value', ''));

		// get properties based on the vendor ID
		Adzuki.Ajax.get('/AllInclusiveProperties/getProperties/' + vendor_id).then(function success(properties) {
			var sorted_properties = Adzuki.Sort.alphabeticValue(properties);

			if (sorted_properties.length > 0) {
				// we have all-inclusives, build select options
				$.each(sorted_properties, function loadProperty(i, property) {
					$properties_select.append($('<option>').text(property.value).attr('value', property.key));
				});

				if (typeof $properties_select.data('selected-id') !== 'undefined') {
					property_id = $properties_select.data('selected-id');
					$properties_select.removeAttr('data-selected-id');
					$properties_select.removeData('selected-id');

					$properties_select.val(property_id);
				}

				$('.component-ai-property[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
			} else {
				// no all-inclusives, so show hotel search field
				$('.component-hotel[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				$('.component_hotels[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
			}
		});
	}

	function getPackageSuppliers(day, component, component_type)
	{
		var $package_supplier_select;

		Adzuki.Ajax.get('/FitBuilders/packageVendorsByType/' + component_type)
		.then(function _adjustSelections(response) {
			$package_supplier_select = $('.package-vendor-select[data-day="' + day + '"][data-component="' + component + '"]');
			$package_supplier_select.empty();
			$package_supplier_select.append($('<option>').text('Please Select').attr('value', ''));

			$.each(response, function _iteratePackageVendors(index, element) {
				$package_supplier_select.append($('<option>').text(element.name).attr('value', element.id));
			});

			$package_supplier_select.prop('disabled', false);
		});
	}

	function getShips(day, component, vendor_id)
	{
		var $ships_select = $('.ship-select[data-day="' + day + '"][data-component="' + component + '"]'),
		    ship_id;

		// reset stuff
		$ships_select.empty();
		$ships_select.append($('<option>').text('').attr('value', ''));

		// get ships based on the vendor ID
		Adzuki.Ajax.get('/Ships/shipsByVendor/' + vendor_id).then(function success(ships) {
			if (ships.length > 0) {
				// we have ships, build select options
				$.each(ships, function loadShip(i, ship) {
					$ships_select.append($('<option>').text(ship.name).attr('value', ship.id));
				});

				if (typeof $ships_select.data('selected-id') !== 'undefined') {
					ship_id = $ships_select.data('selected-id');
					$ships_select.removeAttr('data-selected-id');
					$ships_select.removeData('selected-id');

					$ships_select.val(ship_id);
				}

				$('.component-ship[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
			}
		});
	}

	function initComponentFieldListeners(day, component)
	{
		var day_index         = day - 1,
			component_index   = component - 1,
			field_id          = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-',
			hide_vendor_label = '';

		// attach events
		// destinations
		loadDestinationTypeAhead(day, component);
		resetDestinationTypeAhead(day, component);

		// vendors
		loadVendorTypeAhead(day, component);
		resetVendorTypeAhead(day, component);

		// hotels
		loadHotelTypeAhead(day, component);
		resetHotelTypeAhead(day, component);

		// viator
		loadViatorDestinationTypeAhead(day, component);
		resetViatorTypeAheads(day, component);

		// google
		loadGoogleDestinationTypeAhead(day, component);
		resetGoogleTypeAheads(day, component);

		// text editor fields
		Adzuki.Editor(field_id + 'vendor_notes', {
			editor_type: 'minimal',
			height     : 100,
		});

		Adzuki.Editor(field_id + 'description', {
			editor_type: 'advanced',
			height     : 200,
		});

		// show or hide the destination field based on component type selected
		$('.component-type[data-day="' + day + '"][data-component="' + component + '"]').change(function _showHideDestination() {
			var component_type = $(this).val();

			// show vendor-related fields by default
			$('.component-booking-through[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
			$('.component-type-package-vendor[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
			$('.component-type-vendor[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
			$('.component-type-vendor-notes[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');

			// load the package suppliers based on selected component type
			getPackageSuppliers(day, component, component_type);

			// reset the component vendor field
			$('.reset-component-vendor[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');

			// hide google-related fields by default
			$('.component-google[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			// reset the google fields
			$('.reset-component-google-destination[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');
			$('.reset-component-google-place[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');

			// reset the title field
			$(field_id + 'title').val('');

			// reset the description field
			Adzuki.Editor(field_id + 'description', {
				init_instance_callback: function onEditorInit(_editor) {
					_editor.setContent('');
					$(field_id + 'description').val('');
				},
			});

			// reset the component picture fields
			$(field_id + 'component_picture').val('');
			$(field_id + 'component_library_image').val('');
			$(field_id + 'remove_component_picture').val('');

			$('.selected-component-image[data-day="' + day + '"][data-component="' + component + '"]').attr('src', '');
			$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			// handle vendor field label changes
			switch (component_type) {
				case 'air':
					$('.component-vendor-label[data-day="' + day + '"][data-component="' + component + '"]').html('Airline');
					$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
					$('.fit-builder-template-destination-container[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
					break;
				case 'car':
					$('.component-vendor-label[data-day="' + day + '"][data-component="' + component + '"]').html('Car Rental Company');
					$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
					$('.fit-builder-template-destination-container[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
					break;
				case 'cruise':
					$('.component-vendor-label[data-day="' + day + '"][data-component="' + component + '"]').html('Cruise Line');
					$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
					$('.fit-builder-template-destination-container[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
					break;
				case 'excursion':
					$('.component-vendor-label[data-day="' + day + '"][data-component="' + component + '"]').html('Excursion Company');
					$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
					$('.fit-builder-template-destination-container[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
					break;
				case 'lodging':
					$('.component-vendor-label[data-day="' + day + '"][data-component="' + component + '"]').html('Hotel Chain');
					$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
					$('.fit-builder-template-destination-container[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
					break;
				case 'package':
					$('.component-vendor-label[data-day="' + day + '"][data-component="' + component + '"]').html('Package Supplier');
					$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
					$('.fit-builder-template-destination-container[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
					break;
				case 'rail':
					$('.component-vendor-label[data-day="' + day + '"][data-component="' + component + '"]').html('Rail Company');
					$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
					$('.fit-builder-template-destination-container[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
					break;
				case 'transfer':
					$('.component-vendor-label[data-day="' + day + '"][data-component="' + component + '"]').html('Transfer Company');
					$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
					$('.fit-builder-template-destination-container[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
					break;
				case 'custom':
					$('.fit-builder-template-destination-container[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');

					// reset vendor field
					$('.component-vendor-label[data-day="' + day + '"][data-component="' + component + '"]').html('Vendor');
					$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', true);

					// hide vendor-related fields
					$('.component-booking-through[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
					$('.component-package-vendor[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
					$('.component-type-vendor[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
					$('.component-type-vendor-notes[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

					// reset booking through to tbd
					$(field_id + 'component_packaged_by-0').trigger('click');

					// show google destination field
					$('.google-destination-search[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');

					// init google fields
					$(field_id + 'google_destination').val('');
					$(field_id + 'google_destination_search').val('');
					$(field_id + 'google_destination_search').prop('disabled', false);

					// google place typeahead disabled until destination selected
					$(field_id + 'google_place').val('');
					$(field_id + 'google_place_search').val('');
					$(field_id + 'google_place_search').prop('disabled', true);
					break;
				default:
					$('.component-vendor-label[data-day="' + day + '"][data-component="' + component + '"]').html('Vendor');
					$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', true);
					break;
			}

			// update the "hide vendor" field label based on selected component type
			hide_vendor_label = $('.component-vendor-label[data-day="' + day + '"][data-component="' + component + '"]').text();

			$('.component-hide-vendor-label[data-day="' + day + '"][data-component="' + component + '"]').html('Hide ' + hide_vendor_label + ' in Trip Summary');

			// re-init vendor lookup
			loadVendorTypeAhead(day, component);
		});

		$('.packaged-by[data-day="' + day + '"][data-component="' + component + '"] > .btn-radio').click(function _packagedByClicked() {
			var data_type = $(this).data('type');

			if (data_type === 'supplier') {
				// package supplier
				$('.component-vendor-required[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				$('.component-package-vendor[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
			} else if (data_type === 'direct') {
				// direct
				$('.component-vendor-required[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				$('.component-package-vendor[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
				resetPackageSupplier(day, component);
			} else {
				// unknown
				$('.component-vendor-required[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
				$('.component-package-vendor[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
				resetPackageSupplier(day, component);
			}
		});

		// load component info based on ai property
		$('.ai-property-select[data-day="' + day + '"][data-component="' + component + '"]').change(function _loadPropertyInfo() {
			var property_id = $(this).val();

			Adzuki.Ajax.get('/AllInclusiveProperties/getPropertyDetails/' + property_id).then(function success(property) {
				var title                 = '',
				    destination_id        = '',
				    destination_search    = '',
				    description           = '',
				    component_picture_src = '';

				// reset destination
				$('.reset-destination-link[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');

				// we have property data
				if ($.isEmptyObject(property) === false) {
					// set the component title to the property name
					if (property.name !== '') {
						title = property.name;
					}

					// set the destination if the property has a country set
					if (property.country_id !== '') {
						destination_id     = 'countries_' + property.country_id;
						destination_search = property.country;

						// disable the field and show reset link
						$(field_id + 'destination_search').prop('disabled', true);
						$('.reset-destination[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
					}

					// set the component description to the property description
					if (property.long_description !== '') {
						description = property.long_description;
					}

					// set the component picture to the property featured image
					if (property.image !== '') {
						component_picture_src = Adzuki.homeoffice_url + Adzuki.base_uri + '/' + property.image;
					}
				}

				// set title
				$(field_id + 'title').val(title);

				// set destination values
				$(field_id + 'destination_id').val(destination_id);
				$(field_id + 'destination_search').val(destination_search);

				// set description editor content
				Adzuki.Editor(field_id + 'description', {
					init_instance_callback: function onEditorInit(_editor) {
						_editor.setContent(description);
						$(field_id + 'description').val(description);
					},
				});

				// set component picture
				$(field_id + 'component_picture').val('');
				$(field_id + 'component_library_image').val(component_picture_src);
				$(field_id + 'remove_component_picture').val('');

				// set image preview
				$('.selected-component-image[data-day="' + day + '"][data-component="' + component + '"]').attr('src', component_picture_src);

				// show/hide image preview
				if (component_picture_src === '') {
					$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
				} else {
					$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				}
			});
		});

		// load component info based on ship
		$('.ship-select[data-day="' + day + '"][data-component="' + component + '"]').change(function _loadShipInfo() {
			var ship_id = $(this).val();

			Adzuki.Ajax.get('/Ships/ajaxGetShipDetails/' + ship_id).then(function success(ship) {
				var title                 = '',
				    description           = '',
				    component_picture_src = '';

				// we have ship data
				if ($.isEmptyObject(ship) === false) {
					// set the component title to the cruise line - ship name
					title = ship.cruise_lines.name + ' - ' + ship.ships.name;

					// set the component description to the ship description
					if (ship.ships.description !== '') {
						description = ship.ships.description;
					}

					// set the component picture to the ship image
					if (ship.cruise_lines.image_dir !== '' && ship.ships.image_dir !== '') {
						component_picture_src = Adzuki.homeoffice_url + Adzuki.base_uri + '/images/cruise_lines/' + ship.cruise_lines.image_dir + '/' + ship.ships.image_dir + '/ship.jpg';
					}
				}

				// set title
				$(field_id + 'title').val(title);

				// set description editor content
				Adzuki.Editor(field_id + 'description', {
					init_instance_callback: function onEditorInit(_editor) {
						_editor.setContent(description);
						$(field_id + 'description').val(description);
					},
				});

				// set component picture
				$(field_id + 'component_picture').val('');
				$(field_id + 'component_library_image').val(component_picture_src);
				$(field_id + 'remove_component_picture').val('');

				// set image preview
				$('.selected-component-image[data-day="' + day + '"][data-component="' + component + '"]').attr('src', component_picture_src);

				// show/hide image preview
				if (component_picture_src === '') {
					$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
				} else {
					$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				}
			});
		});

		// component library image
		$('.component-library-select[data-day="' + day + '"][data-component="' + component + '"]').click(function _showComponentImagePicker(e) {
			e.preventDefault();

			showImagePicker(day, component);
		});

		// remove component picture
		$('.remove-component-image[data-day="' + day + '"][data-component="' + component + '"]').click(function _removeComponentLibraryImage(e) {
			var image_id = $(this).data('image_id');

			e.preventDefault();

			$(field_id + 'component_picture').val('');
			$(field_id + 'component_library_image').val('');
			$(field_id + 'remove_component_picture').val(image_id);

			$('.selected-component-image[data-day="' + day + '"][data-component="' + component + '"]').attr('src', '');
			$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
		});

		// remove component button
		$('.remove-component[data-day="' + day + '"][data-component="' + component + '"]').click(function _removeComponentClicked(e) {
			var confirm_day       = $('.day-container[data-day="' + day + '"]').find('.day-title').html(),
				confirm_component = $('.component-container[data-day="' + day + '"][data-component="' + component + '"]').find('.component-title').html();

			e.preventDefault();

			// remove the component, but ask first
			Adzuki.CustomConfirm({
				body   : 'Are you sure you want to remove TRAVEL COMPONENT ' + confirm_component + ' from DAY ' + confirm_day + '?',
				confirm: function removeComponent() {
					var component_to_remove = $('.component-container[data-day="' + day + '"][data-component="' + component + '"]');

					// remove and update the remaining components in the day
					component_to_remove.remove();
					updateComponents(day);

					// Keep the success message from popping up too quickly.
					setTimeout(function _statusMessageTimeout()
					{
						Adzuki.StatusMessage('success', 'Travel component has been removed. PLEASE NOTE: You must click the "Submit" button at the bottom of the form to save the template change.');
					}, 1000);
				}
			});
		});
	}

	function initDayListeners(day)
	{
		// remove day button
		$('.remove-day[data-day="' + day + '"]').click(function _removeDayClicked(e) {
			var day         = $(this).data('day'),
				confirm_day = $('.day-container[data-day="' + day + '"]').find('.day-title').html();

			e.preventDefault();

			// remove the day, but ask first
			Adzuki.CustomConfirm({
				body   : 'Are you sure you want to remove DAY ' + confirm_day + '?',
				confirm: function removeDay() {
					var day_to_remove = $('.day-container[data-day="' + day + '"]');

					// remove and update the remaining days
					day_to_remove.remove();
					updateDays();

					// Keep the success message from popping up too quickly.
					setTimeout(function _statusMessageTimeout()
					{
						Adzuki.StatusMessage('success', 'Day has been removed. PLEASE NOTE: You must click the "Submit" button at the bottom of the form to save the template change.');
					}, 1000);
				}
			});
		});
	}

	function loadDestinationTypeAhead(day, component)
	{
		var day_index       = day - 1,
			component_index = component - 1,
			field_id        = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-';

		Adzuki.Typeahead(
			field_id + 'destination_search',
			'/Searches/destination/all/',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
				$(field_id + 'destination_id').val(item.id);
				$(field_id + 'destination_search').val(item.name);
				$(field_id + 'destination_search').prop('disabled', true);
				$('.reset-destination[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
			},
			null,
			null,
			null,
			true
		);
	}

	function loadGoogleDestinationTypeAhead(day, component)
	{
		var day_index       = day - 1,
			component_index = component - 1,
			field_id        = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-';

		// google destination search
		Adzuki.Typeahead(
			field_id + 'google_destination_search',
			'/Searches/googleLocationSearch/',
			function select(item, $self, typeahead) {
				// handle response
				typeahead.setHiddenValue(item.name);

				// set hidden google_destination
				$(field_id + 'google_destination').val(item.name);

				// set the search field value, disable, and show reset link
				$(field_id + 'google_destination_search').val(item.name);
				$(field_id + 'google_destination_search').prop('disabled', true);

				$('.reset-google-destination-typeahead[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');

				// show the google place search field
				$('.google-place-search[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				$(field_id + 'google_place').val('');
				$(field_id + 'google_place_search').val('');
				$(field_id + 'google_place_search').prop('disabled', false);

				// enable google place search
				loadGooglePlaceTypeAhead(day, component, item);
			},
			null,
			null,
			null,
			true
		);
	}

	function loadGooglePlaceTypeAhead(day, component, google_destination)
	{
		var day_index        = day - 1,
			component_index  = component - 1,
			field_id         = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-',
			place_lookup_url = '/Searches/googlePlaceLookup/' + google_destination.id + '/';

		// google place search
		Adzuki.Typeahead(
			field_id + 'google_place_search',
			place_lookup_url,
			function select(item, $self, typeahead) {
				// handle response
				typeahead.setHiddenValue(item.name);

				// set hidden google_place
				$(field_id + 'google_place').val(item.name);

				// set the search field value, disable, and show reset link
				$(field_id + 'google_place_search').val(item.name);
				$(field_id + 'google_place_search').prop('disabled', true);

				$('.reset-google-place-typeahead[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');

				// set form data based on google place data
				if (item.id) {
					Adzuki.Ajax.get(Adzuki.base_uri + '/Searches/googlePlaceDetails/' + item.id)
					.then(function success(response) {
						setGooglePlaceData(day, component, response, google_destination);
					});
				}
			},
			null,
			null,
			null,
			true
		);
	}

	function loadHotelTypeAhead(day, component)
	{
		var day_index       = day - 1,
			component_index = component - 1,
			field_id        = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-';

		Adzuki.Typeahead(
			field_id + 'hotel_search',
			'/Searches/hotelSearch/',
			function select(item, $self, typeahead) {
				var hotel_search_val = '';

				// handle response
				typeahead.setHiddenValue(item.id);

				if (item.city) {
					hotel_search_val = item.name + ' (' + item.city + ', ' + item.country_code + ')';
				} else {
					hotel_search_val = item.name;
				}

				// set the search field value, disable, and show reset link
				$(field_id + 'hotel_search').val(hotel_search_val);
				$(field_id + 'hotel_search').prop('disabled', true);

				$('.reset-hotel-typeahead[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');

				// set form data based on hotel data
				setHotelData(day, component, item);
			},
			function template(item) {
				var html;

				if (item.city) {
					html = item.name + ' (' + item.city + ', ' + item.country_code + ')';
				} else if (item.street_address_1) {
					html = item.name + ' (' + item.street_address_1 + ')';
				} else {
					html = item.name;
				}

				return html;
			},
			null,
			null,
			true
		);
	}

	function loadVendorTypeAhead(day, component)
	{
		var day_index         = day - 1,
			component_index   = component - 1,
			field_id          = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-',
			component_type    = $(field_id + 'component_type').val(),
			vendor_lookup_url = '/Vendors/searchVendorByType/' + component_type + '/';

		Adzuki.Typeahead(
			field_id + 'vendor_search',
			vendor_lookup_url,
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
				$(field_id + 'vendor_id').val(item.id);

				// show "hide vendor" field
				$('.component-type-hide-vendor[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');

				// attempt to get ai properties for hotel or show hotel search
				if (item.primary_component_type === 'lodging') {
					getAllInclusiveProperties(day, component, item.id);
				}

				// attempt to get ships for cruise line
				if (item.primary_component_type === 'cruise') {
					getShips(day, component, item.id);
				}

				// handle viator destination
				if (item.name_without_type.indexOf('Viator') !== -1) {
					$('.viator-destination-search[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
					$(field_id + 'viator_destination_id').val('');
					$(field_id + 'viator_destination_search').val('');
					$(field_id + 'viator_destination_search').prop('disabled', false);
				}

				// eslint-disable-next-line no-lonely-if
				if ($(field_id + 'component_type').val() === item.primary_component_type) {
					// eslint-disable-next-line no-lonely-if
					if ($(field_id + 'component_type').val() === 'package') {
						$('.add-details-container[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
						$(field_id + 'details_type').val('');
					} else {
						$('.add-details-container[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
						$(field_id + 'details_type').val(item.primary_component_type);
					}
				} else {
					$('.reset-component-vendor[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');
					Adzuki.StatusMessage('error', 'Sorry, the vendor you chose does not support the component type you selected above.');
					$('.component-type[data-day="' + day + '"][data-component="' + component + '"]').val('');
				}
			},
			null,
			null,
			null,
			true
		);
	}

	function loadViatorDestinationTypeAhead(day, component)
	{
		var day_index       = day - 1,
			component_index = component - 1,
			field_id        = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-';

		// viator destination search
		Adzuki.Typeahead(
			field_id + 'viator_destination_search',
			'/Viator/destinationSearch/',
			function select(item, $self, typeahead) {
				// handle response
				typeahead.setHiddenValue(item.destination_id);

				// set hidden viator_destination_id
				$(field_id + 'viator_destination_id').val(item.destination_id);

				// set the search field value, disable, and show reset link
				$(field_id + 'viator_destination_search').val(item.name);
				$(field_id + 'viator_destination_search').prop('disabled', true);

				$('.reset-viator-destination-typeahead[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');

				// show the viator product search field
				$('.viator-search[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				$(field_id + 'viator_product_code').val('');
				$(field_id + 'viator_search').val('');
				$(field_id + 'viator_search').prop('disabled', false);

				// enable viator search
				loadViatorProductTypeAhead(day, component, item.destination_id);
			},
			null,
			null,
			null,
			true
		);
	}

	function loadViatorProductTypeAhead(day, component, viator_destination_id)
	{
		var day_index          = day - 1,
			component_index    = component - 1,
			field_id           = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-',
			product_lookup_url = '/Searches/viator/' + viator_destination_id + '/';

		// viator product search
		Adzuki.Typeahead(
			field_id + 'viator_search',
			product_lookup_url,
			function select(item, $self, typeahead) {
				// handle response
				typeahead.setHiddenValue(item.id);

				// set hidden viator_product_code
				$(field_id + 'viator_product_code').val(item.id);

				// set the search field value, disable, and show reset link
				$(field_id + 'viator_search').val(item.name + ' (' + item.id + ')');
				$(field_id + 'viator_search').prop('disabled', true);

				$('.reset-viator-typeahead[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');

				// set form data based on viator product data
				if (item.id) {
					setViatorProductData(day, component, item);
				}
			},
			function template(item) {
				var html;

				html = item.name + ' (' + item.id + ')';

				return html;
			},
			null,
			null,
			true
		);
	}

	function resetComponentFields(day, component)
	{
		var day_index       = day - 1,
			component_index = component - 1,
			field_id        = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-';

		// hidden component id field
		$(field_id + 'component_id').val('');

		// resets component type
		resetComponentType(day, component, false);

		// resets booking through / package supplier / vendor fields
		$('.btn-radio[data-type="unknown"][data-day="' + day + '"][data-component="' + component + '"]').trigger('click');

		// title field
		$(field_id + 'title').val('');

		// component picture fields
		$(field_id + 'component_picture').val('');
		$(field_id + 'component_library_image').val('');
		$(field_id + 'remove_component_picture').val('');

		$('.selected-component-image[data-day="' + day + '"][data-component="' + component + '"]').attr('src', '');
		$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
	}

	function resetComponentType(day, component, disabled)
	{
		var $component_type_select = $('.component-type[data-day="' + day + '"][data-component="' + component + '"]');

		Adzuki.Ajax.get('/FitBuilders/componentTypes')
		.then(function _adjustSelections(response) {
			$component_type_select.empty();
			$component_type_select.append($('<option>').text('Please Select').attr('value', ''));

			$.each(response, function _iterateTypes(index, element) {
				if (index !== 'package') {
					$component_type_select.append($('<option>').text(element).attr('value', index));
				}
			});

			// append "Custom" type
			$component_type_select.append($('<option>').text('Custom').attr('value', 'custom'));

			$component_type_select.prop('disabled', disabled);

			$('.component-type[data-day="' + day + '"][data-component="' + component + '"]').trigger('change');

			// reset the vendor lookup
			$('.reset-component-vendor[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');
			$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', true);
		});
	}

	// reset destination link
	function resetDestinationTypeAhead(day, component)
	{
		var day_index       = day - 1,
			component_index = component - 1,
			field_id        = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-';

		$('.reset-destination-link[data-day="' + day + '"][data-component="' + component + '"]').click(function _resetDestination(e) {
			e.preventDefault();

			$('.component_destination[data-day="' + day + '"][data-component="' + component + '"]').val('');
			$('.component_destination[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
			$('.reset-destination[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			$(field_id + 'destination_id').val('');
		});
	}

	// reset google destination/place links
	function resetGoogleTypeAheads(day, component)
	{
		var day_index       = day - 1,
			component_index = component - 1,
			field_id        = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-';

		// reset component google destination link
		$('.reset-component-google-destination[data-day="' + day + '"][data-component="' + component + '"]').click(function _clearGoogleDestination(e) {
			e.preventDefault();

			$(field_id + 'google_destination').val('');
			$(field_id + 'google_destination_search').val('');
			$(field_id + 'google_destination_search').prop('disabled', false);

			// hide reset link
			$('.reset-google-destination-typeahead[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			// trigger place reset
			$('.reset-component-google-place[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');

			// hide the place search, only shows when destination selected
			$('.google-place-search[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			// reset destination
			$('.reset-destination-link[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');
		});

		// reset component google place link
		$('.reset-component-google-place[data-day="' + day + '"][data-component="' + component + '"]').click(function _clearGooglePlace(e) {
			e.preventDefault();

			$(field_id + 'google_place').val('');
			$(field_id + 'google_place_search').val('');
			$(field_id + 'google_place_search').prop('disabled', false);

			// hide reset link
			$('.reset-google-place-typeahead[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
		});
	}

	// reset hotel link
	function resetHotelTypeAhead(day, component)
	{
		var day_index       = day - 1,
			component_index = component - 1,
			field_id        = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-';

		// reset component hotel link
		$('.reset-component-hotel[data-day="' + day + '"][data-component="' + component + '"]').click(function _clearDetailLinks(e) {
			e.preventDefault();

			$('.component_hotels[data-day="' + day + '"][data-component="' + component + '"]').val('');
			$('.component_hotels[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
			$('.reset-hotel-typeahead[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			$(field_id + 'hotel_giata_id').val('');

			// clear out the component details that were set based on the hotel data
			// set title
			$(field_id + 'title').val('');

			// set destination values
			$(field_id + 'destination_id').val('');
			$(field_id + 'destination_search').val('');
			$(field_id + 'destination_search').prop('disabled', false);

			// set description editor content
			Adzuki.Editor(field_id + 'description', {
				init_instance_callback: function onEditorInit(_editor) {
					_editor.setContent('');
					$(field_id + 'description').val('');
				},
			});

			// clear component picture
			$(field_id + 'component_picture').val('');
			$(field_id + 'component_library_image').val('');
			$(field_id + 'remove_component_picture').val('');

			// clear image preview
			$('.selected-component-image[data-day="' + day + '"][data-component="' + component + '"]').attr('src', '');

			// hide image preview
			$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
		});
	}

	// reset package supplier
	function resetPackageSupplier(day, component)
	{
		var $package_supplier_select = $('.package-vendor-select[data-day="' + day + '"][data-component="' + component + '"]');

		$package_supplier_select.val('');
	}

	// reset vendor link
	function resetVendorTypeAhead(day, component)
	{
		var day_index       = day - 1,
			component_index = component - 1,
			field_id        = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-';

		// reset component vendor link
		$('.reset-component-vendor[data-day="' + day + '"][data-component="' + component + '"]').click(function _clearDetailLinks(e) {
			e.preventDefault();

			$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').val('');
			$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
			$('.reset-typeahead[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			$(field_id + 'vendor_id').val('');

			// hide "hide vendor" field
			$('.component-type-hide-vendor[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
			$(field_id + 'hide_vendor').prop('checked', false);

			// clear out the ai property and hide it too
			$(field_id + 'all_inclusive_property_id').val('');
			$('.component-ai-property[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			// clear out the hotel search and hide it too
			$(field_id + 'hotel_giata_id').val('');
			$(field_id + 'hotel_search').val('');
			$(field_id + 'hotel_search').prop('disabled', true);
			$('.component-hotel[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			// clear out the ship and hide it too
			$(field_id + 'ship_id').val('');
			$('.component-ship[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			// clear out the viator fields and hide them too
			$(field_id + 'viator_destination_id').val('');
			$(field_id + 'viator_destination_search').val('');
			$(field_id + 'viator_product_code').val('');
			$(field_id + 'viator_search').val('');
			$('.component-viator[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
		});
	}

	// reset viator destination/product links
	function resetViatorTypeAheads(day, component)
	{
		var day_index       = day - 1,
			component_index = component - 1,
			field_id        = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-';

		// reset component viator destination link
		$('.reset-component-viator-destination[data-day="' + day + '"][data-component="' + component + '"]').click(function _clearViatorDestination(e) {
			e.preventDefault();

			$(field_id + 'viator_destination_id').val('');
			$(field_id + 'viator_destination_search').val('');
			$(field_id + 'viator_destination_search').prop('disabled', false);

			// hide reset link
			$('.reset-viator-destination-typeahead[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			// trigger product reset
			$('.reset-component-viator[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');

			// hide the product search, only shows when destination selected
			$('.viator-search[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
		});

		// reset component viator product link
		$('.reset-component-viator[data-day="' + day + '"][data-component="' + component + '"]').click(function _clearViatorProduct(e) {
			e.preventDefault();

			$(field_id + 'viator_product_code').val('');
			$(field_id + 'viator_search').val('');
			$(field_id + 'viator_search').prop('disabled', false);

			// hide reset link
			$('.reset-viator-typeahead[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
		});
	}

	function setGooglePlaceData(day, component, google_place, google_destination)
	{
		var day_index             = day - 1,
			component_index       = component - 1,
			field_id              = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-',
			description           = '',
			destination_id        = '',
			destination_search    = '',
			component_picture_src = '';

		// set title to google place name
		$(field_id + 'title').val(google_place.name);

		// reset destination
		$('.reset-destination-link[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');
console.log(google_place);
console.log(google_destination);
		// set the destination if the google place has a matched city
		if (google_destination.city_id !== null && google_destination.city_id !== '') {
			destination_id     = 'cities_' + google_destination.city_id;
			destination_search = google_destination.city_name;

			if (google_destination.city_state_name !== null && google_destination.city_state_name !== '') {
				destination_search = destination_search + ', ' + google_destination.city_state_name;
			}

			if (google_destination.city_country_name !== null && google_destination.city_country_name !== '') {
				destination_search = destination_search + ', ' + google_destination.city_country_name;
			}

			// disable the field and show reset link
			$(field_id + 'destination_search').prop('disabled', true);
			$('.reset-destination[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
		}

		// set the component description to the website
		if (google_place.website) {
			description += '<p>Website: <a href="' + google_place.website + '" target="_blank">' + google_place.website + '</a></p>';
		}

		// and address
		if (google_place.html_address) {
			description += '<p>Address: ' + google_place.html_address + '</p>';
		}

		// set the component picture to the first place image
		if (google_place.images.length > 0) {
			component_picture_src = Adzuki.base_uri + '/Searches/googleImageConvert/' + google_place.images[0].photo_reference;
		}

		// set destination values
		$(field_id + 'destination_id').val(destination_id);
		$(field_id + 'destination_search').val(destination_search);

		// set description editor content
		Adzuki.Editor(field_id + 'description', {
			init_instance_callback: function onEditorInit(_editor) {
				_editor.setContent(description);
				$(field_id + 'description').val(description);
			},
		});

		// set component picture
		$(field_id + 'component_picture').val('');
		$(field_id + 'component_library_image').val(component_picture_src);
		$(field_id + 'remove_component_picture').val('');

		// set image preview
		$('.selected-component-image[data-day="' + day + '"][data-component="' + component + '"]').attr('src', component_picture_src);

		// show/hide image preview
		if (component_picture_src === '') {
			$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
		} else {
			$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
		}
	}

	function setHotelData(day, component, hotel)
	{
		var day_index             = day - 1,
			component_index       = component - 1,
			field_id              = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-',
			description           = '',
			destination_id        = '',
			destination_search    = '',
			component_picture_src = '';

		// set hidden hotel_giata_id
		$(field_id + 'hotel_giata_id').val(hotel.giata_id);

		// set title to hotel name
		$(field_id + 'title').val(hotel.name);

		if (hotel.giata_id) {
			// get more hotel info
			Adzuki.Ajax.get(Adzuki.base_uri + '/HotelEngine/hotelMetaData/' + hotel.giata_id)
			.then(function success(response) {
				// reset destination
				$('.reset-destination-link[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');

				// we have property data
				if ($.isEmptyObject(response) === false) {
					// set the destination if the property has a city set
					if (response.city_id !== '') {
						destination_id     = 'cities_' + response.city_id;
						destination_search = response.city_name;

						if (response.city_state_name !== '') {
							destination_search = destination_search + ', ' + response.city_state_name;
						}

						if (response.city_country_name !== '') {
							destination_search = destination_search + ', ' + response.city_country_name;
						}

						// disable the field and show reset link
						$(field_id + 'destination_search').prop('disabled', true);
						$('.reset-destination[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
					}

					if ($.isEmptyObject(response.metadata.property) === false) {
						// set the component description to the property room description
						if (response.metadata.property.description_rooms !== '' && response.metadata.property.description_rooms !== 'undefined') {
							description = description + '<strong>About the Property</strong><br>' + response.metadata.property.description_rooms + '<br><br>';
						}

						// and amenities description
						if (response.metadata.property.description_amenities !== '' && response.metadata.property.description_amenities !== 'undefined') {
							description = description + '<strong>Property Amenities</strong><br>' + response.metadata.property.description_amenities + '<br><br>';
						}

						// set the component picture to the first property image
						if (response.metadata.images) {
							component_picture_src = response.metadata.images[0]['large'];
						}
					}
				}

				// set destination values
				$(field_id + 'destination_id').val(destination_id);
				$(field_id + 'destination_search').val(destination_search);

				// set description editor content
				Adzuki.Editor(field_id + 'description', {
					init_instance_callback: function onEditorInit(_editor) {
						_editor.setContent(description);
						$(field_id + 'description').val(description);
					},
				});

				// set component picture
				$(field_id + 'component_picture').val('');
				$(field_id + 'component_library_image').val(component_picture_src);
				$(field_id + 'remove_component_picture').val('');

				// set image preview
				$('.selected-component-image[data-day="' + day + '"][data-component="' + component + '"]').attr('src', component_picture_src);

				// show/hide image preview
				if (component_picture_src === '') {
					$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
				} else {
					$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				}
			});
		}
	}

	function setViatorProductData(day, component, viator)
	{
		var day_index             = day - 1,
			component_index       = component - 1,
			field_id              = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-',
			description           = '',
			destination_id        = '',
			destination_search    = '',
			component_picture_src = '';

		// set title to product name
		$(field_id + 'title').val(viator.name);

		// reset destination
		$('.reset-destination-link[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');

		// set the destination if the viator product has a matched city
		if (viator.city_id !== '') {
			destination_id     = 'cities_' + viator.city_id;
			destination_search = viator.city_name;

			if (viator.city_state_name !== '') {
				destination_search = destination_search + ', ' + viator.city_state_name;
			}

			if (viator.city_country_name !== '') {
				destination_search = destination_search + ', ' + viator.city_country_name;
			}

			// disable the field and show reset link
			$(field_id + 'destination_search').prop('disabled', true);
			$('.reset-destination[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
		}

		// set the component description to the product description
		if (viator.short_description !== '') {
			description = viator.short_description;
		}

		// set the component picture to the viator image
		if (viator.thumbnail_hi_res_url) {
			component_picture_src = viator.thumbnail_hi_res_url;
		}

		// set destination values
		$(field_id + 'destination_id').val(destination_id);
		$(field_id + 'destination_search').val(destination_search);

		// set description editor content
		Adzuki.Editor(field_id + 'description', {
			init_instance_callback: function onEditorInit(_editor) {
				_editor.setContent(description);
				$(field_id + 'description').val(description);
			},
		});

		// set component picture
		$(field_id + 'component_picture').val('');
		$(field_id + 'component_library_image').val(component_picture_src);
		$(field_id + 'remove_component_picture').val('');

		// set image preview
		$('.selected-component-image[data-day="' + day + '"][data-component="' + component + '"]').attr('src', component_picture_src);

		// show/hide image preview
		if (component_picture_src === '') {
			$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
		} else {
			$('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
		}
	}

	function showImagePicker(day = null, component = null)
	{
		var $image_library_preview,
			$id_picture,
			$id_library_image,
			$id_remove_picture,
			$selected_image,
			$selected_image_remove,
			day_index,
			component_index,
			field_id;

		// change the element references based on having day/component or not
		if (day !== null && component !== null) {
			day_index              = String(day - 1);
			component_index        = String(component - 1);
			field_id               = '#fitbuildertemplate-days-' + day_index + '-components-' + component_index + '-';
			$image_library_preview = $('.image-library-preview[data-day="' + day + '"][data-component="' + component + '"]');
			$id_picture            = $(field_id + 'component_picture');
			$id_library_image      = $(field_id + 'component_library_image');
			$id_remove_picture     = $(field_id + 'remove_component_picture');
			$selected_image        = $('.selected-component-image[data-day="' + day + '"][data-component="' + component + '"]');
			$selected_image_remove = $('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]');
		} else {
			$image_library_preview = $('.image-library-preview');
			$id_picture            = $('#fitbuildertemplate-picture');
			$id_library_image      = $('#fitbuildertemplate-library_image');
			$id_remove_picture     = $('#fitbuildertemplate-remove_picture');
			$selected_image        = $('.selected-image');
			$selected_image_remove = $('.selected-image-remove');
		}

		$image_library_preview.attr('src', '');

		$modal.addClass('wide');
		$modal.find('.modal-title').text('Image Library');
		$modal.find('.modal-body').text('Loading image library...');

		Adzuki.Ajax.get('/Images/imagePicker')
		.then(function _showImagePicker(html) {
			$modal.find('.modal-body').html(html);

			Adzuki.Form.initAjaxForm('ImageSearch');
		});

		$modal.on('click', '.image-picker .select-image', function selectImage() {
			var $image = $(this).parents('.image-container').find('img'),
				$src   = $image.attr('src');

			$id_picture.val('');
			$id_library_image.val($src);
			$id_remove_picture.val('');
			$selected_image.attr('src', $src);

			$selected_image_remove.removeClass('hidden');

			$modal.modal('hide');
		});

		$modal.on('click', '.add-button-btn', function addImageButtonPressed() {
			Adzuki.CustomConfirm({
				title  : 'Add image?',
				content: 'Adding images must be done through the Image section of the web program. Clicking \'Ok\' will take you there now. Would you like to go? Please note any unsaved work may be lost.',
				confirm: function confirm() {
					document.location = Adzuki.webprogram_url + Adzuki.base_uri + '/Images/add/';
				}
			});
		});

		$modal.on('hidden.bs.modal', function _restoreModal() {
			$modal.removeClass('wide').off('hidden.bs.modal')
				  .off('click', '.image-picker .select-image');
		}).modal('show');
	}

	/**
	 * Update the number on all of the existing components
	 * for the specified day
	 *
	 * @param  {string} day
	 *
	 * @return {void}
	 */
	function updateComponents(day)
	{
		var component_count = $('.component-container[data-day="' + day + '"]').length;

		// update the number on all of the component elements
		$('.component-container[data-day="' + day + '"]').each(function onEachDayElement(i, elem) {
			var day_index        = String(day - 1),
				component_index  = i,
				component_number = String(i + 1),
				cloned_element   = $(elem).clone(),
				cloned_parent    = $(elem).parent(),
				vendor_notes     = '',
				description      = '';

			// change container component title
			cloned_element.find('.component-title').html(component_number);

			// change the container component number
			cloned_element.attr('data-component', component_number);

			// toggle the close icon class based on day number or number of components the day
			if (day > 1 || component_count > 1) {
				cloned_element.find('.remove-component-container').removeClass('hidden');
			} else {
				cloned_element.find('.remove-component-container').addClass('hidden');
			}

			// update the component number attribute on all of the component elements
			cloned_element.find('[data-day="' + day + '"]').each(function onEachComponentElement(c, compElem) {
				// change data attributes on the markup elements
				$(compElem).attr('data-component', component_number);
			});

			// update the form fields id and name
			cloned_element.find('.component-field').each(function onEachFieldElement(f, fieldElem) {
				var field_id    = $(fieldElem).attr('id'),
					field_type  = $('#' + field_id).attr('type'),
					field_value = $('#' + field_id).val(),
					numeric_key = '';

				// change the field id
				$id_field_pieces     = field_id.split('-');
				$id_field_piece_name = $id_field_pieces.pop();

				// need to avoid numeric keys if the field name is based on radio buttons
				if (isNaN(parseInt($id_field_piece_name)) === false) {
					numeric_key          = '-' + $id_field_piece_name;
					$id_field_piece_name = $id_field_pieces.pop();
				}

				// use component_index
				$id_field = $label_name + '-days-' + day_index + '-components-' + component_index + '-' + $id_field_piece_name + numeric_key;

				$(fieldElem).attr('id', $id_field);

				// change the field name
				$name_field = $form_name + '[days][' + day_index + '][components][' + component_index + '][' + $id_field_piece_name + ']';

				$(fieldElem).attr('name', $name_field);

				// set the field value based on the type
				switch (field_type) {
					case 'select':
						field_value = $('#' + field_id).prop('selectedIndex');

						$(fieldElem).prop('selectedIndex', field_value);
						break;
					default:
						$(fieldElem).val(field_value);
						break;
				}

				// set text editor field values for use below
				if ($id_field_piece_name === 'vendor_notes') {
					vendor_notes = field_value;
				}

				if ($id_field_piece_name === 'description') {
					description = field_value;
				}
			});

			// reset text editor fields and set their values so they can be re-initialized
			cloned_element.find('.vendor-notes[data-day="' + day + '"][data-component="' + component_number + '"]').html(
				'<textarea type="textarea" class="form-control component-field" data-day="' + day + '" data-component="' + component_number + '" name="form_component_data[FitBuilderTemplate][days][' + day_index + '][components][' + component_index + '][vendor_notes]" id="' + $label_name + '-days-' + day_index + '-components-' + component_index + '-vendor_notes">' + vendor_notes + '</textarea>'
			);

			cloned_element.find('.description[data-day="' + day + '"][data-component="' + component_number + '"]').html(
				'<textarea type="textarea" class="form-control component-field" data-day="' + day + '" data-component="' + component_number + '" name="form_component_data[FitBuilderTemplate][days][' + day_index + '][components][' + component_index + '][description]" id="' + $label_name + '-days-' + day_index + '-components-' + component_index + '-description">' + description + '</textarea>'
			);

			// remove the element
			$(elem).remove();

			// add the cloned component to the dom
			cloned_parent.append(cloned_element);

			// attach events
			initComponentFieldListeners(day, component_number);
		});
	}

	/**
	 * Update the number on all of the existing days and their components
	 * for the specified day
	 *
	 * @return {void}
	 */
	function updateDays()
	{
		var day_count = $('.day-container').length;

		// update the day number display
		$('.day-container').each(function onEachDayElement(i, elem) {
			var day_number                 = String(i + 1),
				element_current_day_number = String($(elem).data('day'));

			if (day_number !== element_current_day_number) {
				// change the container day number
				$(elem).attr('data-day', day_number);

				// change day title
				$(elem).find('.day-title')
					   .html(day_number);

				// change the hidden day_number field
				$id_field   = $label_name + '-days-' + i + '-day_number';
				$name_field = $form_name + '[days][' + i + '][day_number]';

				$(elem).find('.day-number')
					   .val(day_number)
					   .attr('id', $id_field)
					   .attr('name', $name_field);

				// update the day number attribute on all of the day elements
				$(elem).find('[data-day]').each(function onEachComponentContainerElement(d, dayElem) {
					// change data attributes on the markup elements
					$(dayElem).attr('data-day', day_number);
				});

				// toggle the close icon class based on number of days
				if (day_count > 1) {
					$(elem).find('.remove-day-container').removeClass('hidden');
				} else {
					$(elem).find('.remove-day-container').addClass('hidden');
				}

				// trigger update on the day's components
				updateComponents(day_number);

				// enable add component link
				addComponentEvent();
			}
		});
	}
}(jQuery, window.Adzuki || {}));
